import mixpanel from 'mixpanel-browser'

// Initialize Mixpanel with your project token
const API_HOST = import.meta.env.VITE_API_HOST
const MIAPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN

if (!MIAPANEL_TOKEN) {
  console.error('VITE_MIXPANEL_TOKEN= is not defined in environment')
}

if (!API_HOST) {
  console.error('API_HOST= is not defined in environment')
}

mixpanel.init(MIAPANEL_TOKEN, {
  debug: true,
  api_host: API_HOST,
  track_pageview: true,
  persistence: 'localStorage',
})

export const trackEvent = (eventName: string, properties = {}) => {
  try {
    mixpanel.track(eventName, properties)
  } catch (error: any) {
    // console.error(`Error tracking event ${eventName}:`, error)
  }
}

// You can also export other analytics-related functions here if needed
export const identifyUser = (userId: string, userProperties = {}) => {
  mixpanel.identify(userId)
  mixpanel.people.set(userProperties)
}
